var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kst-section',{attrs:{"title":_vm.sectionTitle}},[_c('Edit',{attrs:{"access":_vm.access,"editDispatch":_vm.editDispatch,"userDispatches":_vm.userDispatches}}),_c('List',{attrs:{"access":_vm.access,"userDispatches":_vm.userDispatches}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }